import React, { useState } from 'react';
import AlertDisplay from 'components/AlertDisplay';
import { alertNames } from 'util/alertsUrgency';

const GeneralAlerts = ({ alerts }) => {
  const [fullInfoShown, setFullInfoShown] = useState(false);

  const toggleFullInfo = () => setFullInfoShown(!fullInfoShown);

  return (
    <div className='general-alerts-list'>
      <div className='short-view d-flex justify-content-between align-items-center'>
        <div className='alerts-items d-flex  align-items-center'>
          {Object.keys(alerts).map((item, index) => (
            <div key={index} className={`single-item single-item-${item}`}>
              <span className='single-item-count'>{alerts[item].total}</span>
              <span className='single-item-title'>{alertNames[item]}</span>
            </div>
          ))}
        </div>

        <div
          className='general-alerts-more-info d-flex align-items-center'
          onClick={toggleFullInfo}
        >
          <i
            className={`fas fa-lg fa-angle-${fullInfoShown ? 'up' : 'down'}`}
          />
        </div>
      </div>

      {fullInfoShown && (
        <div className='full-view'>
          <AlertDisplay alerts={alerts} />
        </div>
      )}
    </div>
  );
};

export default GeneralAlerts;
